import { useApiAWS } from '@/composables/useApi'

const apiAws = useApiAWS()

export function GetFrameVideoUrl() {
  this.execute = function (data) {
    return apiAws.post('/frame-video', data).then(res => res.data)
  }
}

export function GetFrameCardVideoUrl() {
  this.execute = function (data) {
    return apiAws.post('/frame-card-video', data).then(res => res.data)
  }
}
